import { apiClient } from "../lib/api";

export const longHourInterviewApi = {
  getPolicy: () => apiClient.get("/long-hour-interviews/policy"),
  updatePolicy: (payload) => apiClient.put("/long-hour-interviews/policy", payload),

  listThresholdRules: () => apiClient.get("/long-hour-interviews/policies/thresholds"),
  createThresholdRule: (payload) => apiClient.post("/long-hour-interviews/policies/thresholds", payload),
  deactivateThresholdRule: (ruleId) => apiClient.post(`/long-hour-interviews/policies/thresholds/${ruleId}/deactivate`),

  detectCandidates: () => apiClient.post("/long-hour-interviews/candidates/detect"),
  listCandidates: (params) => apiClient.get("/long-hour-interviews/candidates", { params }),
  getCandidate: (candidateId) => apiClient.get(`/long-hour-interviews/candidates/${candidateId}`),
  notify: (candidateId) => apiClient.post(`/long-hour-interviews/candidates/${candidateId}/notify`),
  offer: (candidateId) => apiClient.post(`/long-hour-interviews/candidates/${candidateId}/offer`),
  request: (candidateId) => apiClient.post(`/long-hour-interviews/candidates/${candidateId}/request`),
  scheduleAppointment: (candidateId, appointment_date) => apiClient.post(`/long-hour-interviews/candidates/${candidateId}/appointment`, { appointment_date }),
  acknowledgeCompletion: (candidateId) => apiClient.post(`/long-hour-interviews/candidates/${candidateId}/complete`),
  recordPhysicianOpinion: (candidateId, status, notes) => apiClient.post(`/long-hour-interviews/candidates/${candidateId}/physician-opinion`, { status, notes }),
  updateEmploymentMeasure: (candidateId, status, follow_up_due_date, reviewer) =>
    apiClient.post(`/long-hour-interviews/candidates/${candidateId}/employment-measure`, { status, follow_up_due_date, reviewer }),
  closeCandidate: (candidateId) => apiClient.post(`/long-hour-interviews/candidates/${candidateId}/close`),
};
